import axios from '../axios/interceptor';

export const createBooking = async (businessId,bookingData) => {
    const response = await axios.post(`/business/${businessId}/booking`, bookingData);
    return response.data; 
}

export const retrieveBookings = async (businessId,from,to,status) => {
    const response = await axios.get(`/business/${businessId}/booking?from=${from}&to=${to}&status=${status}`);
    return response.data; 
}

export const cancelBooking = async (businessId,bookingId) => {
    const response = await axios.delete(`/business/${businessId}/booking/${bookingId}`);
    return response.data; 
}

export const bookingDetails = async (businessId,bookingId,includeBookedItem=null,includeServices=null,includeSecondaryCollector=null,includeNotes=null) => {
    const params = {
        includeBookedItem: includeBookedItem,
        includeServices: includeServices,
        includeSecondaryCollector: includeSecondaryCollector,
        includeNotes: includeNotes
    }
    const response = await axios.get(`/business/${businessId}/booking/${bookingId}/details`,{params});
    return response.data; 
}

export const updateBookingJob= async(businessId,bookingId,updateData) => {
    const response = await axios.put(`/business/${businessId}/booking/${bookingId}/job`, updateData);
    return response.data; 
}

export const bookingPayment= async(businessId,bookingId,paymentData) => {
    const response = await axios.post(`/business/${businessId}/booking/${bookingId}/payment`, paymentData);
    return response.data; 
}

export const createOTP= async(businessId,bookingId) => {
    const response = await axios.post(`/business/${businessId}/booking/${bookingId}/otp`);
    return response.data; 
}

export const submitBookingCollection= async(businessId,bookingId,otpPayload) => {
    const response = await axios.post(`/business/${businessId}/booking/${bookingId}/collection`, otpPayload);
    return response.data; 
}